import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import animate from 'animate.css';
import schema from 'async-validator';
import dialog from './utils/dialog';
import $scroll from '@utils/loading';
import cookie from '@utils/store/cookie';
import vant from 'vant';
import { resizePageFontSize } from '@utils';
import 'vant/lib/index.css';

import '@assets/iconfont/iconfont.css';
import '@assets/css/style.scss';
import { parseQuery } from '@utils'; //isWeixin,
import { Lazyload } from 'vant';

Vue.use(vant);
Vue.use(animate);
Vue.use(Lazyload);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.prototype.$validator = function(rule) {
    return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

const CACHE_KEY = 'clear_0.0.1';

if (!cookie.has(CACHE_KEY)) {
    cookie.clearAll();
    cookie.set(CACHE_KEY, 1);
}

let cookieName = 'debug';
let query = parseQuery();
// let urlSpread = query['spread'];
let vconsole = query[cookieName.toLowerCase()];
let debug = '1'; //开启vconsole模式
let undebug = '0'; //关闭vconsole模式

// if (urlSpread !== undefined) {
// var spread = cookie.get('spread');
// urlSpread = parseInt(urlSpread);
// if (urlSpread != '' && spread !== urlSpread) {
//   cookie.set('spread', urlSpread || '', 1);
// }
//  else if (spread === 0 || typeof spread !== "number") {
//   cookie.set("spread", urlSpread || 0);
// }
// }

if (vconsole !== undefined) {
    if (vconsole === undebug && cookie.has(cookieName)) cookie.remove(cookieName);
} else vconsole = cookie.get(cookieName);

if (vconsole !== undefined && vconsole === debug) {
    cookie.set(cookieName, debug, 3600);
    const module = () => import('vconsole');
    module().then(Module => {
        new Module.default();
    });
}
resizePageFontSize();

new Vue({
    el: '#app',
    router,
    store,
    // i18n,
    render: h => h(App)
});

// setTimeout(() => {
//   $vm.$mount('#app');
// }, 200);
